import axios from 'axios';
import { createContext, useEffect, useRef, useState } from 'react';
import secureLocalStorage from 'react-secure-storage';

const MyContext = createContext();

const MyProvider = ({ children }) => {

    const BaseUrl = process.env.REACT_APP_API_URL || "http://localhost:3005/";
    // const BaseUrl = "https://samples-toolbox-lying-import.trycloudflare.com/";
    const MapKey = secureLocalStorage.getItem("google_map_key") || "AIzaSyAuW0G7juF4y672HVqU1h7OBcNEr4TdoBE";

    const [toastmsg, setToastMsg] = useState("");
    const [istoast, setIsToast] = useState(false);
    const [userlogin, setUserLogin] = useState(0);
    const [isauth, setIsAuth] = useState(false);
    const [paymentRes, setPaymentRes] = useState("");
    const [paymentloading, setPaymentLoading] = useState(false);
    const [israting, setIsRating] = useState(false);
    const [ratingdata, setRatingData] = useState("");
    const [agoraAppId, setAgoraAppId] = useState("");
    const [isReqModel, setIsReqModel] = useState(false);
    const [modelData, setModelData] = useState("");

    const BookRef = useRef(false);

    const HandleCallApi = async (method, ApiUrl, ApiData) => {
        let res;
        try {
            if (method === "Post") {
                const Response = await axios.post(`${BaseUrl}${ApiUrl}`, ApiData);
                res = Response;
            }
            if (method === "Get") {
                const Response = await axios.get(`${BaseUrl}${ApiUrl}`, ApiData);
                res = Response;
            }
            console.log(`${ApiUrl} :-->>`, res);
            return res;
        } catch (error) {
            console.error(`${ApiUrl} :-->>`, error);
        }
    };

    useEffect(() => {
        const data = secureLocalStorage.getItem("isAuthenticated") || false;
        setIsAuth(data);
    }, []);

    const formatPrice = (amount, decimalPlaces = null) => {
        const currency = secureLocalStorage.getItem("currency") || "$";
        const placement = secureLocalStorage.getItem("currency_placement") || "0"; 
        const separatorType = secureLocalStorage.getItem("thousands_separator") || "1";

        if (amount === undefined || amount === null || isNaN(Number(amount))) {
            return "";
        }

        let numStr;
        if (decimalPlaces !== null) {
            numStr = Number(amount).toFixed(decimalPlaces);
        } else {
            const cleanAmount = Number(Number(amount).toFixed(12));
            if (Number.isInteger(cleanAmount)) {
                numStr = cleanAmount.toString();
            } else {
                numStr = cleanAmount.toFixed(2);
            }
        }
        let parts = numStr.split(".");
        let integerPart = parts[0];
        let decimalPart = parts.length > 1 ? "." + parts[1] : "";

        let sep = ",";
        if (separatorType === "1" || separatorType === 1) sep = ",";
        else if (separatorType === "2" || separatorType === 2) sep = ".";
        else if (separatorType === "3" || separatorType === 3) sep = "`";
        else if (separatorType === "4" || separatorType === 4) sep = "";
        else if (separatorType === "5" || separatorType === 5) sep = " ";

        if (sep) {
            integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
        }

        const formattedAmount = integerPart + decimalPart;

        if (placement === "1" || placement === 1) {
            return `${formattedAmount}${currency}`;
        } else {
            return `${currency}${formattedAmount}`;
        }
    };

    const value = {
        toastmsg, setToastMsg,
        istoast, setIsToast,
        userlogin, setUserLogin,
        isauth, setIsAuth,
        paymentRes, setPaymentRes,
        paymentloading, setPaymentLoading,
        israting, setIsRating,
        ratingdata, setRatingData,
        agoraAppId, setAgoraAppId,
        isReqModel, setIsReqModel,
        modelData, setModelData,
        BookRef,
        BaseUrl, HandleCallApi, MapKey, formatPrice
    }

    return (
        <MyContext.Provider value={value}>
            {children}
        </MyContext.Provider>
    )
}

export { MyContext, MyProvider }